import { useEffect, useState } from "react";
import './EditProfile.css';
import utils from "../../Functions/utils";

const EditProfile = () => {
  const [userData, setUserData] = useState({fName : "", lName : "", phone : "", email : "", });
  const [successMsg, setSuccessMsg] = useState("");
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);


  
  // ---------- useEffect - טענת מידע מהשרת ----------  
  useEffect(() => {
    const fetchData = async () => {
      await fetchUserData();
    };
    fetchData();
  }, []);

  const fetchUserData = async () => {
    const localKey = 'userData';
    try {
      const cached = localStorage.getItem(localKey);
      if (cached) {
        setUserData(JSON.parse(cached));
      } else {
        const resp = await utils.requestData('GetUserData', {});
        if (resp[0].code !== 90) throw new Error(resp[0].msg);
        setUserData(resp[0]);
        localStorage.setItem(localKey, JSON.stringify(resp[0]));
      }
    } catch (err) {
      console.error('Error fetching userData:', err);
      setError(err.message);
    }
  };
  
  
  const handleSubmit = async() => {

    // console.log("handleSubmit")
    const updateUserData = async () => {
      try {

        const localKey = 'userData';
        // console.log(userData)
        await utils.requestData("UpdateUserData", userData);
                
        const resp = await utils.requestData('GetUserData', {});
        // if (resp[0].code !== 90) throw new Error(resp[0].msg);
        setUserData(resp[0]);
        localStorage.setItem(localKey, JSON.stringify(resp[0]));

        // console.log(resp[0])
        setSuccessMsg("הפרטים נשמרו בהצלחה!");

      } catch (error) {
        console.error("Error Update ChapterCompletions:", error);
        setLoading(false);
      }
    };

    updateUserData();
        
  };

  return (
    <div className="edit-profile-form">
      <div className="form-group">
        <label>שם פרטי</label>
        <input
          type="text"
          value={userData.fName}
          onChange={(e) => setUserData({...userData, fName:e.target.value})}
        />
      </div>

      <div className="form-group">
        <label>שם משפחה</label>
        <input
          type="text"
          value={userData.lName}
          onChange={(e) => setUserData({...userData, lName:e.target.value})}
        />
      </div>

      <div className="form-group">
        <label>טלפון</label>
        <input
          type="tel"
          value={userData.phone}
          onChange={(e) => setUserData({...userData, phone:e.target.value})}
        />
      </div>


      <div className="form-group">
        <label>אימייל</label>
        <input
          type="email"
          value={userData.email}
          onChange={(e) => setUserData({...userData, email:e.target.value})}
        />
      </div>


      <button className="button" onClick={handleSubmit}>שמור</button>

      {successMsg && <p className="success-message">{successMsg}</p>}
    </div>
  );
};

export default EditProfile;
